import styled from 'styled-components';

// Container for modal content
export const InstructorVerificationContentContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  p {
    margin: 0;
    
    > span {
      display: block;
    }
  }
`;
